/** ErrorBoundary —— 包住 LLM 生成的交互块（aie-game/aie-graph），
 *  模型偶尔吐残缺数据致渲染崩溃时，只降级显示一行提示，不把整个聊天页带崩（"莫名其妙退出"的根治）。 */
import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}
interface State {
  hasError: boolean
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: 12, color: '#999', fontSize: 13, background: '#FFF3E0', borderRadius: 8, margin: '8px 0' }}>
            🤖 这段内容暂时没法显示，让老师重新发一次吧～
          </div>
        )
      )
    }
    return this.props.children
  }
}
